import {SvgIcon} from '@shipwell/shipwell-ui';

function InlineLoading() {
  return <SvgIcon name="LoadingDots" className="m-0 inline-block size-4 p-0" />;
}

export default InlineLoading;
